import {
    type FC
} from "react";
import type IPaginationPreviousProps from "./type";
import {
    NCoreUIKitLocalize
} from "../../../../core/hooks";
import {
    usePaginationContext
} from "../../context";
import {
    PaginationPreviousIcon
} from "../../icons";
import PaginationControl from "../control";

const PaginationPrevious: FC<IPaginationPreviousProps> = ({
    customTheme: customThemeProp,
    isDisabled: isDisabledProp,
    onPress,
    style,
    title
}) => {
    const context = usePaginationContext();

    const {
        localize
    } = NCoreUIKitLocalize.useContext(context.customLocalize);

    const isIconOnly = context.stepTitleBehaviour === "hidden" || (context.stepTitleBehaviour === "auto" && (context.variant === "compact" || context.isCompact));

    const previousPage = Math.max(context.page - 1, 1);

    const handlePress = () => {
        if(onPress) {
            onPress();

            return;
        }

        context.onPageChange(previousPage);
    };

    return <PaginationControl
        href={context.page > 1 ? context.hrefExtractor?.(previousPage) : undefined}
        aria-label={title ?? localize("pagination-previous-page")}
        customTheme={customThemeProp ?? context.customTheme}
        isAriaDisabled={isDisabledProp ?? context.page <= 1}
        title={title ?? localize("pagination-previous")}
        isDisabled={context.isDisabled}
        icon={PaginationPreviousIcon}
        isIconOnly={isIconOnly}
        onPress={handlePress}
        iconDirection="start"
        size={context.size}
        style={style}
        kind="step"
    />;
};
export default PaginationPrevious;
